import { Badge } from "@babackapp/ui/components/badge";
import { Checkbox } from "@babackapp/ui/components/checkbox";
import type { BackfillShop } from "./pii-backfill-shop-row";
import {
  EMAIL_REF_STATUSES,
  type EmailRefStatus,
  type ShopEmailRefSummary,
} from "./pii-email-ref-status";

const STATUS_STYLES: Record<EmailRefStatus, string> = {
  blocked: "bg-muted text-muted-foreground",
  pending: "bg-sky-100 text-sky-800",
  running: "bg-violet-100 text-violet-800",
  paused: "bg-amber-100 text-amber-800",
  done: "bg-green-100 text-green-800",
};

export function PiiEmailRefRow({
  shop,
  summary,
  isSelected,
  onToggle,
}: {
  shop: BackfillShop;
  summary: ShopEmailRefSummary;
  isSelected: boolean;
  onToggle: () => void;
}) {
  const isSelectable = summary.status !== "blocked";
  return (
    <tr className="border-b last:border-0 hover:bg-muted/30">
      <td className="px-3 py-2 w-8">
        <Checkbox
          checked={isSelected}
          disabled={!isSelectable}
          onCheckedChange={onToggle}
        />
      </td>
      <td className="px-3 py-2 font-medium">
        {shop.name}
        {shop.isTestShop && (
          <span className="ml-2 text-xs text-muted-foreground">test</span>
        )}
      </td>
      <td className="px-3 py-2 text-right tabular-nums">
        {shop.totalOrders.toLocaleString("fr-FR")}
      </td>
      <td className="px-3 py-2">
        <Badge variant="outline" className={STATUS_STYLES[summary.status]}>
          {EMAIL_REF_STATUSES[summary.status]}
        </Badge>
      </td>
      <td className="px-3 py-2 w-48">
        {summary.status !== "blocked" && summary.status !== "pending" && (
          <div className="flex items-center gap-2">
            <div className="h-2 flex-1 rounded bg-muted">
              <div
                className="h-2 rounded bg-emerald-500"
                style={{ width: `${summary.percent}%` }}
              />
            </div>
            <span className="text-xs tabular-nums text-muted-foreground">
              {summary.percent} %
            </span>
          </div>
        )}
      </td>
    </tr>
  );
}
